export default "__VITE_ASSET__DNtP1vyd__"